const pad = (value) => String(value).padStart(2, '0');

/**
 * "2026-01-01" for a local date. Never through `toISOString`: that converts to
 * UTC first, and a local midnight east of UTC would land on the day before.
 */
export const toIsoDay = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** Local midnight of 1 January of the current year. */
export const startOfCurrentYear = () =>
  new Date(new Date().getFullYear(), 0, 1);

/** Local midnight of today. */
export const startOfToday = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

const FILE_NAME_FALLBACK = 'entreprise';
const FILE_NAME_SLUG_MAX_LENGTH = 60;

/**
 * Same algorithm as the api's toFileNameSlug, so both name the file alike:
 * ASCII `[a-z0-9-]`, accents dropped, œ and æ spelt out, cut at 60 characters.
 */
export const slugifyCompanyName = (name) => {
  const slug = (typeof name === 'string' ? name : '')
    .normalize('NFKD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, FILE_NAME_SLUG_MAX_LENGTH)
    .replace(/^-+|-+$/g, '');
  return slug || FILE_NAME_FALLBACK;
};

/**
 * Named here, on the api's pattern: CORS does not expose Content-Disposition,
 * so the name the api gives cannot be read.
 */
export const accountStatementFileName = (companyName, from, to) =>
  `releve-de-compte-${slugifyCompanyName(companyName)}-${from}-${to}.pdf`;

const ERROR_TEXTS = {
  PENNYLANE_CUSTOMER_NOT_FOUND: {
    key: 'customerNotFound',
    fallback: 'Cette entreprise n’est pas reliée à un client Pennylane.',
  },
  PENNYLANE_CUSTOMER_AMBIGUOUS: {
    key: 'customerNotFound',
    fallback: 'Cette entreprise n’est pas reliée à un client Pennylane.',
  },
  PENNYLANE_UNAVAILABLE: {
    key: 'pennylaneUnavailable',
    fallback: 'Pennylane ne répond pas, réessayez dans quelques minutes.',
  },
  PENNYLANE_READS_DISABLED: {
    key: 'readsDisabled',
    fallback: 'La lecture de Pennylane est désactivée sur cet environnement.',
  },
  ACCOUNT_STATEMENT_TOO_LARGE: {
    key: 'tooLarge',
    fallback: 'Ce compte contient trop d’écritures pour générer le relevé (plus de 5 000 lignes).',
  },
  INVALID_PERIOD: {
    key: 'invalidPeriod',
    fallback: 'La période est invalide.',
  },
  ACCOUNT_STATEMENT_FORBIDDEN: {
    key: 'forbidden',
    fallback: 'Vous n’avez pas accès au relevé de compte.',
  },
};
const DEFAULT_ERROR_TEXT = {
  key: 'failed',
  fallback: 'Le relevé n’a pas pu être généré.',
};

/** The text shown for an api `errorCode`; any other code gets the generic one. */
export const accountStatementErrorText = (language, errorCode) => {
  const { key, fallback } = ERROR_TEXTS[errorCode] ?? DEFAULT_ERROR_TEXT;
  return language.getValue(`accountStatement.errors.${key}`, fallback);
};
